module.exports = __webpack_public_path__ + "static/img/he5.c502ede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he5.png
// module id = 1caM
// module chunks = 1